import { splitSnapshotSignalTiers } from "@healthos/shared";
import { signalKindLabel } from "../signal-kind-labels.js";
/** What the sources page says about coverage, as data. */
/** How many quiet readings a line names before it counts the rest. */
const COVERAGE_NAMED = 6;
function nameSome(kinds) {
    const named = kinds.slice(0, COVERAGE_NAMED).map(signalKindLabel).join(", ");
    const rest = kinds.length - COVERAGE_NAMED;
    return rest > 0 ? `${named}, and ${rest} more` : named;
}
/** Why a core reading is not here, in the order a member can act on it. */
function coreSayFrom(awaited, missing) {
    const parts = [];
    if (awaited.length > 0) {
        parts.push(awaited.length === 1
            ? `One is connected and has not reported yet: ${nameSome(awaited)}.`
            : `${awaited.length} are connected and have not reported yet: ${nameSome(awaited)}.`);
    }
    if (missing.length > 0) {
        parts.push(missing.length === 1
            ? `One needs a device you have not connected: ${nameSome(missing)}.`
            : `${missing.length} need a device you have not connected: ${nameSome(missing)}.`);
    }
    return parts.length === 0 ? "Every core reading has a source." : parts.join(" ");
}
function additiveSayFrom(reporting, absent) {
    const have = reporting === 0
        ? "None of these are arriving yet."
        : `${reporting} of these ${reporting === 1 ? "is" : "are"} arriving.`;
    // Names what it names, rather than "the rest":
    const rest = absent.length > 0 ? ` You could add a source for ${nameSome(absent)}.` : "";
    return `${have}${rest}`;
}
export function snapshotCoverageProps(coverage) {
    const core = coverage.core ?? { reporting: coverage.reporting, total: coverage.total };
    const awaited = splitSnapshotSignalTiers(coverage.awaited ?? []);
    const missing = splitSnapshotSignalTiers(coverage.missing);
    const additiveTotal = Math.max(0, coverage.total - core.total);
    const additiveReporting = Math.max(0, coverage.reporting - core.reporting);
    return {
        core,
        coreSay: coreSayFrom(awaited.core, missing.core),
        additiveTotal,
        additiveSay: additiveTotal === 0
            ? null
            : additiveSayFrom(additiveReporting, [...awaited.additive, ...missing.additive]),
    };
}
//# sourceMappingURL=snapshot-coverage.js.map